export enum RESPONSE_TOKEN {
    EQUIPO_CREADO = 2,
    TOKEN_VIGENTE_CON_VALIDA = 3,
    TOKEN_NO_VIGENTE = 4,
    TOKEN_NO_EXISTE = 5,
    LOADING = 0,
}

